export * from './contact.component'; 
export * from './splash/splash.component'; 
export * from './content/content.component'; 